import { defineMessages } from 'react-intl';

export const practiceSeatUpgradeCardMessages = defineMessages({
  forCareTeams: {
    id: 'DHoBC/JGTC',
    defaultMessage: 'For care teams',
    description: 'Badge on the Practice plan card shown to Practice Standard teams',
  },
  practice: {
    id: 'g3MPWN94vz',
    defaultMessage: 'Practice',
    description: 'Plan name on the Practice plan card shown to Practice Standard teams',
  },
  yearlyOnly: {
    id: 'fY1q2f0r3M',
    defaultMessage: 'Yearly only',
    description: 'Pill on the Practice plan card saying the plan is only billed yearly',
  },
  standardSeat: {
    id: '4jb2no82PP',
    defaultMessage: '<strong>Standard seat:</strong> {price} user/month*',
    description:
      'Standard seat line on the Practice plan card. {price} is a formatted monthly price; the asterisk points at the sales tax footnote.',
  },
  standardSeatDescription: {
    id: 'yQKN1UyXkg',
    defaultMessage: 'Run the whole practice on Heidi',
    description: 'Supporting copy under the Standard seat line on the Practice plan card',
  },
  maxSeat: {
    id: 'eQiMKnkD1i',
    defaultMessage: '<strong>Max seat:</strong> {price} user/month*',
    description:
      'Max seat line on the Practice plan card. {price} is a formatted monthly price; the asterisk points at the sales tax footnote.',
  },
  maxSeatDescription: {
    id: '9MK8kZnJ2K',
    defaultMessage: 'For teams who use Agents daily',
    description: 'Supporting copy under the Max seat line on the Practice plan card',
  },
  getPractice: {
    id: 'Z/4jVasmaV',
    defaultMessage: 'Get Practice',
    description: 'Button on the Practice plan card that opens the seat checkout',
  },
  getPracticeMax: {
    id: 'RFBmyjbbUX',
    defaultMessage: 'Get Practice Max',
    description:
      'Button on the Practice plan card shown to a Practice Standard team; opens the seat checkout to move members to Max',
  },
  selectSeatsNextStep: {
    id: 'bj0+yORZ6l',
    defaultMessage: 'You’ll select seats in the next step',
    description: 'Caption under the Get Practice button on the Practice plan card',
  },
  everythingInPracticePlus: {
    id: 'kuwpLiRWHV',
    defaultMessage: 'Everything in Practice Standard, plus:',
    description: 'Lead-in above the Max seat feature list on the Practice plan card',
  },
  featureMaxUsage: {
    id: 'snPQxg3nvH',
    defaultMessage: 'Maximum usage allowance for agentic workflows',
    description: 'Max seat feature on the Practice plan card',
  },
  featureRegularAgenticUse: {
    id: 'Yq0T6NZuyZ',
    defaultMessage: 'Designed for regular agentic use',
    description: 'Max seat feature on the Practice plan card',
  },
  featureEarlyAccess: {
    id: 'qUBa6EkHLu',
    defaultMessage: 'Early access to advanced agentic features',
    description: 'Max seat feature on the Practice plan card',
  },
  everythingInScribeTeamPlus: {
    id: 't2JFDF0jI7',
    defaultMessage: 'Everything in Scribe Team, plus:',
    description:
      'Lead-in above the Practice feature list on the Practice plan card shown to Scribe Team teams',
  },
  featureEvidenceAnswers: {
    id: 'EzGKRufn3U',
    defaultMessage: 'Evidence answers in patient sessions',
    description: 'Practice feature on the Practice plan card shown to Scribe Team teams',
  },
  featureEvidenceSources: {
    id: 'Q1jWzg/jt3',
    defaultMessage: 'Choose your preferred Evidence sources',
    description: 'Practice feature on the Practice plan card shown to Scribe Team teams',
  },
  featureEvidenceLibraries: {
    id: 'lLnAmXAQ3W',
    defaultMessage: 'Create personal and team Evidence libraries',
    description: 'Practice feature on the Practice plan card shown to Scribe Team teams',
  },
});
